import { TaskAssignmentService } from 'src/tmc-yard/components/task-assignment/service/task-assignment.service';
import { Task } from 'src/tmc-yard/components/task-assignment/model/task';
import { RegistrationStepperModel } from './../../model/registration-step-model';
import { ActionType } from './../../model/action-type.enum';
import { StationLevel } from './../../model/station-level.enum';
import { RoutingPosition } from './../../model/routing-position';
import { moveItemInArray, CdkDragDrop } from '@angular/cdk/drag-drop';
import { TransportRegistration } from './../../model/transport-registration';
import { TranslationService } from '@sdbn/common';
import { TransportRegistrationService } from './../../service/transport-registration.service';
import { Component, OnInit, Input, AfterViewInit, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { StationType } from '../../model/station-type.enum';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { AsyncSubject } from 'rxjs';
import { ConfigurationService } from '@sdbn/appclient';
import { NgForm } from '@angular/forms';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { StructureSelectionService } from 'src/tmc-yard/common/structure-selection/structure-selection-dialog/structure-selection-dialog-service';
import { StructureSelection } from 'src/tmc-yard/common/structure-selection/structure-selection.model';
import { TransportRouteSelection } from '../../model/out/transport-route-selection';
import { TMCClientParameters } from 'src/tmc-common/tmc-client-parameters';
import { StationAssignmentStrategy } from 'src/tmc-yard/common/station-assignment-strategy/station-assignment-strategy.model';

export interface ActionTypeOption {
  option: ActionType;
  name: string;
}

@Component({
  selector: 'app-route',
  templateUrl: './route.component.html',
  styleUrls: ['./route.component.scss']
})
export class RouteComponent implements OnInit, AfterViewInit {

  @ViewChild('routeForm') routeForm: NgForm;

  isLoading = false;

  @Input() registration: TransportRegistration;
  @Input() stepperModel: RegistrationStepperModel;

  actionTypeOptions: ActionTypeOption[] = [];

  clientParameters = TMCClientParameters;

  shuttleTransportsEnabled = false;

  stationAssignmentStrategyOptions = new Array<StationAssignmentStrategy>();

  constructor(
    private registrationService: TransportRegistrationService,
    public translationService: TranslationService,
    public cps: ConfigurationService,
    private structureSelectionService: StructureSelectionService,
    private tmcContextService: TmcContextService,
    private dialog: MatDialog,
    private taskAssignmentService: TaskAssignmentService
  ) {

    for (const k of Object.keys(StationAssignmentStrategy)) {
      this.stationAssignmentStrategyOptions.push(StationAssignmentStrategy[k]);
    }

    if (this.cps.isEnabled(this.clientParameters.FEATURES_SHUTTLE_TRANSPORTS, false)) {
      this.shuttleTransportsEnabled = true;
    }

  }

  ngOnInit() {


  }

  ngAfterViewInit(): void {
    for (const k of Object.keys(ActionType)) {
      this.actionTypeOptions.push({ option: ActionType[k], name: k });
    }

    this.stepperModel.stepCompleted = () => {
      return this.isStepCompleted();
    };

    this.stepperModel.beforeShowNextStep = () => {
      const subject = new AsyncSubject<boolean>();
      subject.next(true);
      subject.complete();
      return subject;
    };

    if (this.registration.routingPositions.length === 0) {
      this.updateRouteForSelectedOptions();
    }
    this.markFormAsTouched();
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.registration.routingPositions, event.previousIndex, event.currentIndex);
    this.updatePositionsIndex();
  }

  removePosition(position: RoutingPosition) {
    const index = this.registration.routingPositions.indexOf(position);
    this.registration.routingPositions.splice(index, 1);
    if (this.registration.routingPositions.length === 0) {
      this.addPosition();
    }
    this.updatePositionsIndex();

  }

  updatePositionsIndex() {
    for (let i = 0; i < this.registration.routingPositions.length; i++) {
      this.registration.routingPositions[i].index = i;
    }
  }

  assignStation(position: RoutingPosition) {

    const structureSelection = new StructureSelection();

    // TODO structureSelectionService erweitern
    // selectStationEvent.includeStations = true;
    // selectStationEvent.includeWaitingareas = false;
    if (position.stationLevel === StationLevel.STATION_GROUP) {
      structureSelection.stationGroupId = position.stationId;
    } else if (position.stationLevel === StationLevel.STATION_SET) {
      structureSelection.stationSetId = position.stationId;
    } else if (position.stationLevel === StationLevel.STATION) {
      structureSelection.stationId = position.stationId;
    }

    this.structureSelectionService.selectStationSetOrStation(structureSelection).subscribe(
      value => {

        const selection: StructureSelection = value;

        if (value != null) {
          if (selection.stationId != null) {
            position.stationLevel = StationLevel.STATION;
            position.stationId = selection.stationId;
            position.stationType = StationType.WORKING_AREA;
            const station = this.tmcContextService.findStationById(selection.stationId);
            position.stationName = station.name;
            if (station.stationType === StationType.WAITING_AREA) {
              position.stationType = StationType.WAITING_AREA;
              position.actionType = ActionType.NONE;
              position.waitingForRetrieve = false;
              position.cargo = '';
            }
          } else if (selection.stationSetId != null) {
            position.stationLevel = StationLevel.STATION_SET;
            position.stationId = selection.stationSetId;
            const stationSet = this.tmcContextService.findStationSetById(selection.stationSetId);
            position.stationName = stationSet.name;
            position.stationType = StationType.WORKING_AREA;
          } else if (selection.stationGroupId != null) {
            position.stationLevel = StationLevel.STATION_GROUP;
            position.stationId = selection.stationGroupId;
            position.stationName = this.tmcContextService.findStationGroupById(selection.stationGroupId).name;
            position.stationType = StationType.WORKING_AREA;
          }
        }

      }, error => {
        console.error(error);
      });
  }

  addPosition() {
    const position = new RoutingPosition();
    position.index = this.registration.routingPositions.length;
    position.actionType = ActionType.UNLOAD;
    this.registration.routingPositions.push(position);
  }

  isActionTypeDisabled(position: RoutingPosition) {
    return position.stationType === StationType.WAITING_AREA || position.readonly;
  }

  isCargoTypeDisabled(position: RoutingPosition) {
    return position.stationType === StationType.WAITING_AREA || position.readonly;
  }

  isWaitingForRetrieveDisabled(position: RoutingPosition) {
    return position.stationType === StationType.WAITING_AREA || position.readonly;
  }

  isPredictedDurationDisabled(position: RoutingPosition) {
    return position.stationType === StationType.WAITING_AREA || position.readonly;
  }

  isStationAssignmentStrategyRequired(position: RoutingPosition): boolean {
    return position.stationLevel == StationLevel.STATION_SET;
  }

  isStationAssignmentStrategyDisabled(position: RoutingPosition): boolean {
    return this.isLoading || !this.registration.changeRouteManually || position.stationLevel !== StationLevel.STATION_SET || position.readonly;
  }

  isStepCompleted() {
    if (this.isLoading) {
      return false;
    }
    return this.checkPositions();
  }

  checkPositions(): boolean {

    for (let i = 0; i < this.registration.routingPositions.length; i += 1) {

      const rp = this.registration.routingPositions[i];

      /* es muss immer eine Station ID und einen Station Type geben */
      if (!rp.stationType || !rp.stationId) {
        return false;
      }

      /* Bearbeitungsstationen weiter prüfen */
      if (rp.stationType === StationType.WORKING_AREA) {

        /* es muss einen Action Type geben */
        if (!rp.stationType) {
          return false;
        }

        /* wenn Cargo Pflicht ist dann auf Cargo prüfen */
        if (this.isCargoRequired(rp) && !rp.cargo) {
          return false;
        }

        /* geplante Durchlaufzeit muss gesetzt sein */
        if (rp.predictedDuration != null && rp.predictedDuration < 0) {
          return false;
        }

      }

      if (rp.stationLevel === StationLevel.STATION_SET && rp.stationAssignmentStrategy == null) {
        return false;
      }

    }
    return true;
  }

  updateRouteForSelectedOptions() {

    const selection = new TransportRouteSelection();
    selection.vehicleId = this.registration.vehicleId;
    selection.transportOptions = this.registration.selectedOptions;

    this.registrationService.getPositionsforTransportOptions(selection).subscribe(route => {
      this.registration.routingPositions = [];
      this.registration.changeRouteManually = route.changeRouteManually;
      for (const p of route.routingPositions) {
        this.registration.routingPositions.push(p);
        this.updatePositionsIndex();
      }
      this.markFormAsTouched();
    }, error => {
      console.log('error updating route for transport options', error);
    });
  }

  reloadRoute() {

    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc.transport.registration.reload-route.confirm-dialog.title',
      messageKey: 'tmc.transport.registration.reload-route.confirm-dialog.message',
      confirm: () => this.updateRouteForSelectedOptions()
    };
    this.dialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  isCargoRequired(position: RoutingPosition) {
    return position.cargoMandatory || this.cps.isRequired('visitoverview.register.minlength.cargo', true);
  }

  assignTasks(position: RoutingPosition) {
    const editTasks: Task[] = [];
    if (position.tasks) {
      for (const t of position.tasks) {
        const dTask = new Task({});
        dTask.id = t.id;
        dTask.relevance = t.relevance;
        dTask.processingStatus = t.processingStatus;
        editTasks.push(dTask);
      }
    }

    this.taskAssignmentService.openAssignmentDialog(editTasks, position.processingStatusModel).subscribe(next => {
      if (next != null) {
        position.tasks = [];
        for (const n of next) {
          position.tasks.push({ id: n.id, relevance: n.relevance, processingStatus: n.processingStatus });
        }
      }
    });
  }

  getAssignedTasksCount(position: RoutingPosition) {
    return position.tasks.length;
  }

  private markFormAsTouched() {
    setTimeout(() => {
      Object.keys(this.routeForm.controls).forEach(key => {
        this.routeForm.controls[key].markAsTouched();
      });
    }, 125);
  }
}
